module.exports = __webpack_public_path__ + "img/contact-item3.6b08a509.png";